/**
 * @file TextElementPanels.tsx
 * @description Панели текстовых элементов секции (phase19.16 Р2;
 * uiux-design-r2 §4): «Заголовок» (текст и уровень H1–H3 с предупреждением
 * о втором H1), «Надпись» (стиль-основа), «Текст» (абзацы через пустую
 * строку; правится и прямо на канве).
 *
 * SB120 этап 3а (uiux-sb120-stage3 §2.1, §3): размер заголовка — числом в
 * группе «Цвет и шрифт» (`typo.main.size`, ступени [H3][H2][H1] по шкале
 * темы); у «Надписи» стиль `preset` [КАПСОМ][Акцентом] — основа, поверх
 * которой шрифт, размер и цвет из группы «Цвет и шрифт».
 */

import { SECTION_TEXT_LIMITS } from "@chaiberi/shared";

import { SectionTextField } from "../fields/SectionTextField";
import { CaptionPresetField } from "./CaptionPresetField";
import { HeadingLevelField } from "./HeadingLevelField";
import type { ElementPanelProps } from "./types";

const T = SECTION_TEXT_LIMITS;

export function HeadingPanel({ element, onChange, path, otherH1 }: ElementPanelProps<"heading">) {
  return (
    <>
      <SectionTextField label="Текст заголовка" path={`${path}.text`} value={element.text} max={T.heading} onChange={(text) => onChange({ ...element, text })} />
      <HeadingLevelField level={element.level} otherH1={otherH1} onChange={(level) => onChange({ ...element, level })} />
    </>
  );
}

export function EyebrowPanel({ element, onChange, path }: ElementPanelProps<"eyebrow">) {
  return (
    <>
      <SectionTextField label="Текст надписи" path={`${path}.text`} value={element.text} max={T.eyebrow} onChange={(text) => onChange({ ...element, text })} />
      <CaptionPresetField value={element.preset} onChange={(preset) => onChange({ ...element, preset })} />
    </>
  );
}

export function TextPanel({ element, onChange, path }: ElementPanelProps<"text">) {
  return (
    <SectionTextField
      label="Текст"
      path={`${path}.text`}
      value={element.text}
      max={T.text}
      multiline
      hint="Абзацы — через пустую строку. Текст можно править и прямо на сайте слева: второй клик по нему."
      onChange={(text) => onChange({ ...element, text })}
    />
  );
}
